import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixDialog from '@radix-ui/react-dialog';
/**
 * Generic modal dialog. Wraps Radix Dialog with a standard backdrop + centered card.
 * Children render inside the panel — bring your own layout/header/footer.
 */
export function Dialog({ open, onOpenChange, ariaLabel, ariaDescribedBy, maxWidthClassName = 'max-w-md', className = '', children, }) {
    return (_jsx(RadixDialog.Root, { open: open, onOpenChange: onOpenChange, children: _jsxs(RadixDialog.Portal, { children: [_jsx(RadixDialog.Overlay, { className: "fixed inset-0 z-50 bg-blacktext/70" }), _jsx(RadixDialog.Content, { "aria-label": ariaLabel, "aria-describedby": ariaDescribedBy, className: `fixed top-1/2 left-1/2 z-50 w-[calc(100%-32px)] ${maxWidthClassName} -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded outline-none ${className}`, children: children })] }) }));
}
export const DialogTitle = RadixDialog.Title;
export const DialogDescription = RadixDialog.Description;
export const DialogClose = RadixDialog.Close;
